import React from 'react'
import ambu from '../../../assets/mainIcon/icons/ambulance-1 1.png'

export default function AmbulanceIcon() {
  return (
          <img draggable='false' src={ambu} alt="notification" className="ambulance-icon"/>
  )
}
